export const environment = {
  production: false,
  env: 'test',
  baseUrl: 'https://api-pahdp.clients-test.aws.alterna-energie.fr/v1',
  wsUrl: 'wss://api-pahdp-ws.clients-test.aws.alterna-energie.fr/notification',
  sso: {
    cognitoDomain: 'https://pahdp-user-test.auth.eu-central-1.amazoncognito.com',
    identityProvider: 'pahdp-test-azure-provider',
    clientId: '45fuvrocta9sdt3lpdlrh511rg',
    frontendUrl: 'https://test-pricy.alterna-energie.fr',
  },
};
